<template>
  <div class="wrapper">
    <AppBtn
      v-if="step > 1"
      :disabled="loading"
      size="large"
      flat still
      @click="$emit('back')"
    >
      <ChevronMarker dir="back" class="me-2" />
      {{ $tt('previous') }}
    </AppBtn>
    <AppBtn
      v-if="step != lastStep"
      :loading
      class="next"
      size="large"
      primary flat still
      @click="$emit('next')"
    >
      {{ $tt('next') }}
      <ChevronMarker dir="next" class="ms-2" />
    </AppBtn>
  </div>
</template>

<script setup lang="ts">
defineEmits(['next', 'back']);
defineProps<{
  step: number;
  lastStep: number;
  loading: boolean;
}>();
</script>

<style scoped>
.wrapper {
  display: flex;
}
:deep(button) {
  height: 64px !important;
  flex-grow: 1;
  border-radius: 0;
  border-end-start-radius: 6px;
  border-end-end-radius: 6px;
  font-size: 18px;
}
.next {
  flex-grow: 3;
}
</style>